// import { parser /*,serialize*/ } from "js-cookie";
// export function setCookie(...args){
//     document.cookie=serialize(...args);
// }
export function setCookie(name, value, time = 1) {
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000 * time);
  document.cookie =
    name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}
export function getCookie() {
  //   console.log(document.cookie.split(";"));
  if (document.cookie.indexOf("CRM_TOKEN") == -1) {
    return document.cookie;
  } else {
    const token = document.cookie
      .split(";")
      .filter((item) => item.indexOf("CRM_TOKEN") !== -1);
    return token[0].split("=")[1];
  }
}
export function delCookie(name) {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
